import React from "react";
import Box from "../../../components/Box/Box";
import WelcomeCard from "../../../components/ContactInfo/WelcomeCard";
import VirtualList from 'rc-virtual-list';
import moment from "moment";
import { Row, Col, Space, Card, Image, List, Switch, Calendar, Divider, Typography, Modal, Button, Badge, Avatar, Flex, Progress } from "antd";
import { useDispatch } from "react-redux";
import { getData } from "../../../actions/apiCall";
import TaskManagement from "../task_management";
import ReportingCards from "../ReportingCards";
import SummaryCard from "./SummaryCard";
import { useSelector } from "react-redux";
import { constants } from "../../../constants/common";
import Timesheet from "./Timesheet";

const { Title, Text } = Typography
const { useState, useEffect } = React;

// const getTimeDuration = (startTime: string | Date): string => {
//     const start = new Date(startTime);
//     const now = new Date();
//     const diffMs = now.getTime() - start.getTime();

//     const hours = Math.floor(diffMs / (1000 * 60 * 60));
//     const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
//     const seconds = Math.floor((diffMs % (1000 * 60)) / 1000);

//     return `${hours}:${minutes}:${seconds}`;
// };

// const extractTime = (isoString: string): Date => {
//     const date = new Date(isoString);
//     const now = new Date();
//     now.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), 0);
//     return now;
// };

const Welcome: React.FC = () => {
    const [userList, setUserList] = useState<any[]>([]);
    const [holidayList, setHolidayList] = useState<any[]>([]);
    const [visible, setVisible] = useState<boolean>(false);
    const [event, setEvent] = useState<any>(null);
    const [isModalVisible, setIsModalVisible] = useState<boolean>(false);
    const { user } = useSelector((state: any) => state.app);
    const [attendance, setAttendance] = useState<any>(null);
    const [timeText, setTimeText] = useState('0:0:0');
    const [currentTime, setCurrentTime] = useState(moment().format('hh:mm:ss A'));
    const [progress, setProgress] = useState(0);

    const dispatch = useDispatch();

    // useEffect(() => {
    //     if (attendance) {
    //         const updateProgress = () => {
    //             setTimeText(getTimeDuration(attendance?.startDate))
    //             const today = new Date().toLocaleString("en-US", { weekday: "long" }); // Get current day
    //             const todaySchedule = user?.shiftType?.shiftTimings[today as keyof typeof user.shiftType.shiftTimings];

    //             if (!todaySchedule) {
    //                 setProgress(0);
    //                 return;
    //             }

    //             const startTime = extractTime(todaySchedule.start);
    //             const endTime = extractTime(todaySchedule.end);
    //             const now = new Date();

    //             const totalWorkMs = endTime.getTime() - startTime.getTime();
    //             const elapsedMs = now.getTime() - new Date(attendance?.startDate).getTime();
    //             const percentComplete = (elapsedMs / totalWorkMs) * 100;
    //             setProgress(Math.min(100, percentComplete));
    //         };

    //         const interval = setInterval(() => updateProgress(), 1000);

    //         return () => clearInterval(interval);
    //     } else {
    //         const interval = setInterval(() => {
    //             setCurrentTime(moment().format('hh:mm:ss A'))
    //         }, 1000);

    //         return () => clearInterval(interval);
    //     }
    // }, [attendance?.startDate]);



    useEffect(() => {
        getBirthday();
        getHoliday();
        // getCurrentStatus();
    }, [])

    // const showModal = () => {
    //     setIsModalVisible(true)
    // };

    // const handleConfirm = () => {
    //     setIsModalVisible(false)
    //     getCurrentStatus();
    // };

    // const handleCancel = () => {
    //     console.log('Cancelled!');
    //     setIsModalVisible(false)
    // };


    const getBirthday = async () => {
        const { data } = await dispatch(
            getData('/users/upcoming/birthday/list')
        );
        setUserList(data);
    }

    const getHoliday = async () => {
        const { data } = await dispatch(
            getData('/holiday/upcomming/holiday')
        );
        setHolidayList(data)
    }


    const getModal = () => {
        return (
            <>
                <Modal
                    maskClosable={true}
                    open={visible}
                    destroyOnClose={true}
                    title="View"
                    onCancel={() => setVisible(false)}
                    footer={[
                        <Button
                            key="back"
                            onClick={() => setVisible(false)}
                            className="mr-2"
                        >
                            Cancel
                        </Button>,
                    ]}
                >
                    <>
                        {!event && <p>No Events Found</p>}
                        {event &&
                            event.map((ele) => (
                                <div className="row">
                                    <div className="col-12">
                                        <h6>{ele.name}</h6>
                                    </div>
                                    <div className="col-12">
                                        <Image
                                            width={'100%'}
                                            src={process.env.FILE_URL + ele.file}
                                        />
                                    </div>
                                    <div className="col-12">
                                        <p>{ele.description}</p>
                                    </div>
                                </div>
                            ))}
                    </>
                </Modal>
            </>
        );
    }

    const getListData = (value) => {
        const listData = [];

        if (holidayList && holidayList.length) {
            holidayList.forEach((ele) => {
                if (
                    value.date() == parseInt(moment(ele.holidayOn).format('DD')) &&
                    value.month() ==
                    parseInt(moment(ele.holidayOn).subtract(1, 'month').format('M'))
                ) {
                    listData.push({ type: 'error', content: ele.name });
                }
            });
        }
        return listData || [];
    }

    const dateCellRender = (value) => {
        const listData = getListData(value);
        return (
            <ul className="events">
                {listData.map((item) => (
                    <li key={item.content}>
                        <Badge status={item.type} text={item.content} />
                    </li>
                ))}
            </ul>
        );
    }

    // const askForStatus = () => {
    //     showModal();
    // };

    // const getCurrentStatus = async () => {
    //     const resData = await dispatch(getData('/attendance-logs'))
    //     if (resData) {
    //         setAttendance(resData.data)
    //     }
    // }

    const onSelect = (value) => {
        const event = [];
        holidayList.forEach((element) => {
            if (
                value.date() == parseInt(moment(element.holidayOn).format('DD')) &&
                value.month() ==
                parseInt(moment(element.holidayOn).subtract(1, 'month').format('M'))
            ) {
                event.push(element);
            }
        });
        if (event.length > 0) {
            setVisible(true)
            setEvent(event)
        }
    }

    return <>
        {/* {isModalVisible && React.cloneElement(<TaskManagement
            attendance={attendance}
            open={isModalVisible}
            onConfirm={handleConfirm}
            onCancel={handleCancel}
        />)} */}
        {/* <CustomModal open={isCompleteProfile} onCancel={() => setCompleteProfile(false)} title="Complete Profile">
            <CompleteProfile />
        </CustomModal> */}
        {getModal()}
        <Row gutter={8}>
            <Col span={20}>
                <Space direction='vertical'>
                    <Row gutter={8}>
                        <Col span={6}>
                            <WelcomeCard
                                message="We're thrilled to welcome you to our team and embark on this exciting journey together"
                                name={user ? constants.GET_FULL_NAME(user) : ''}
                                title='Welcome to Accelgrowth'
                                avatarUrl={`${process.env.FILE_URL}${user?.avatar}`}
                            />
                        </Col>
                        <Col span={18}>
                            <SummaryCard />
                        </Col>
                    </Row>
                    <Row gutter={8}>
                        <Col span={12}>
                            <Box
                                title="Up-Coming Birthday's"
                            >
                                <List>
                                    <VirtualList
                                        data={userList}
                                        height={310}
                                        itemHeight={47}
                                        itemKey="email"
                                    >
                                        {(item) => (
                                            <List.Item>
                                                <List.Item.Meta
                                                    avatar={
                                                        <Avatar
                                                            shape="square"
                                                            size={50}
                                                            src={`${process.env.FILE_URL}${item?.avatar}`}
                                                        >
                                                            {item.avatar ? '' : [item?.firstName[0], item?.lastName[0]].join('')}
                                                        </Avatar>
                                                    }
                                                    title={
                                                        <a href="#">
                                                            {item ? constants.GET_FULL_NAME(item) : ''}
                                                        </a>
                                                    }
                                                    description={`${item ? constants.GET_FULL_NAME(item) : ''} has birthday on ${moment(
                                                        item.dob
                                                    ).format('DD MMM')} ${moment().format('YYYY')}`}
                                                />
                                            </List.Item>
                                        )}
                                    </VirtualList>
                                </List>
                            </Box>
                        </Col>
                        <Col span={12}>
                            {/* <Box
                                title={'Timesheet'}>
                                <div className="flex justify-center items-center h-full w-full">
                                    {attendance ? <>
                                        <div className="flex flex-row justify-evenly items-center bg-white p-4 space-x-4" >
                                            <Space>
                                                <Progress
                                                    percent={progress}
                                                    type="dashboard"
                                                    size={"default"}
                                                    key={1}
                                                    format={(date) => timeText}
                                                />
                                            </Space>
                                            <Space direction="vertical" className="contact_info">
                                                <div>
                                                    <Title className="noLine" level={5}>Check in at</Title>
                                                    <Text type="secondary">{moment(attendance?.startDate).format('lll')}</Text>
                                                </div>
                                                <div>
                                                    <Button type="default" onClick={() => askForStatus()}>Clock out</Button>
                                                </div>
                                            </Space>
                                        </div>
                                    </> : <>
                                        <div className="flex flex-row justify-evenly items-center bg-white p-4 space-x-4" >
                                            <Space>
                                                <Progress
                                                    percent={0}
                                                    type="dashboard"
                                                    size={"default"}
                                                    key={1}
                                                    format={(date) => currentTime}
                                                />
                                            </Space>
                                            <Space direction="vertical" className="contact_info">
                                                <div>
                                                    <Title className="noLine" level={5}>Mark Your Attendance</Title>
                                                    <Text type="secondary">Click the "Clock In" button to mark your attendance for today.</Text>
                                                </div>
                                                <div>
                                                    <Button type="default" onClick={() => askForStatus()}>Clock In</Button>
                                                </div>
                                            </Space>
                                        </div>
                                    </>}
                                </div>
                                <div className="flex justify-center">
                                    <Text>
                                        Note: Clock-in is allowed only once per day, so do not clock out if you haven't finished your day.
                                    </Text>
                                </div>
                            </Box> */}
                            <Timesheet />
                        </Col>
                    </Row>
                    <Row gutter={8}>
                        <Col span={24}>
                            <Box
                                title={'Holiday(s)'}
                            >
                                <Calendar
                                    dateCellRender={(e) => dateCellRender(e)}
                                    onSelect={(e) => onSelect(e)}
                                />
                            </Box>
                        </Col>
                    </Row>
                </Space>
            </Col>
            <Col span={4}>
                <ReportingCards />
            </Col>
        </Row>
    </>
}

export default Welcome;